enum FileUploadStatus
{
	InProgress,
	Success,
	Failed
}

export default FileUploadStatus;